var cilCaretLeft = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M400.358,496h-36.45L96,256.286,365.811,16.333h34.547ZM144.071,256.358,368.358,457.042V56.892Z' class='ci-primary'/>"];

export { cilCaretLeft };

